import {Component, computed, effect, inject, input, output, viewChild} from '@angular/core';
import {FolderSummary} from '../../../../../api';
import {TranslatePipe} from '@ngx-translate/core';
import {UserDropdown} from '../../../../components/user-dropdown/user-dropdown';
import {TextInput} from '../../../../components/text-input/text-input';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {CurrentUserService} from '../../../../services/current-user.service';

@Component({
  selector: 'elcia-folder-form',
  imports: [TranslatePipe, UserDropdown, TextInput],
  templateUrl: './folder-form.html',
})
export class FolderForm {
  folderInitial = input<FolderSummary>();
  parentFolder = input<FolderSummary>();
  onSubmit = output<{ name: string; userIds: number[] }>();
  currentUserService = inject(CurrentUserService);
  currentUser = computed(() => this.currentUserService.currentUser());
  userDropdown = viewChild(UserDropdown);
  hHussin = computed(() => this.userDropdown()?.users().find(u => u.email == "hhussin@elcia.com"))
  defaultUserIds = computed(() => {
      const defaultUserIds = [] as number[];
      const hhId = this.hHussin()?.id;
      const currentUserId = this.currentUser()?.id
      if (hhId) defaultUserIds.push(hhId);
      if (currentUserId) defaultUserIds.push(currentUserId);

      return defaultUserIds.distinct();
    }
  );

  onDefaultUserChange = effect(() => {
    if (this.currentUser()) {
      if (!this.form.controls.userIds.value?.includes(this.currentUser()!.id)) {
        this.form.controls.userIds.setValue([...this.form.controls.userIds.value ?? [], this.currentUser()!.id]);
      }
    }
    if (this.hHussin()) {
      if (!this.form.controls.userIds.value?.includes(this.hHussin()!.id)) {
        this.form.controls.userIds.setValue([...this.form.controls.userIds.value ?? [], this.hHussin()!.id]);
      }
    }
  })

  onInitialChange = effect(() => {
    const initial = this.folderInitial();
    this.form.controls.name.setValue(initial?.name ?? '');
    this.form.controls.userIds.setValue(initial?.userAccess?.map(u => u.id) ?? []);
  });


  protected form = new FormGroup({
    name: new FormControl('', Validators.required),
    userIds: new FormControl<number[]>([]),
  });


  submit() {
    this.form.markAllAsTouched();
    if (this.form.invalid) return;
    const {name, userIds} = this.form.getRawValue();
    this.onSubmit.emit({name: name!.trim(), userIds: userIds ?? []});
  }
}
